import React, { useCallback, useEffect, useRef } from 'react'
import Flex from '../Flex'
import Text from '../Text'
import { InfiniteScrollProps } from './InfiniteScroll.types'

const InfiniteScroll: React.FC<InfiniteScrollProps> = ({
  hasNextPage,
  children,
  onChange,
  isMobile,
  isLoading,
  page = 1,
  loader,
}) => {
  const observerElem = useRef(null)
  const handleObserver = useCallback(
    (entries) => {
      const [target] = entries

      if (target.isIntersecting) {
        onChange()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hasNextPage],
  )

  useEffect(() => {
    const element = observerElem.current

    if (element) {
      const option = { threshold: 0 }

      const observer = new IntersectionObserver(handleObserver, option)
      observer.observe(element)

      return () => observer.unobserve(element)
    }
  }, [page, hasNextPage, handleObserver, observerElem, children, isLoading])

  return (
    <>
      {children}

      {hasNextPage && !isLoading && <Flex aria-label='hasNextPage' ref={observerElem} p='16px' />}

      {isLoading &&
        page !== 1 &&
        (loader || (
          <Flex width='100%' justifyContent='center' backgroundColor='white' py='16px'>
            {(loader && isMobile) || (
              <Text variant='caption' color='black75'>
                Loading...
              </Text>
            )}
          </Flex>
        ))}
    </>
  )
}

export default InfiniteScroll
